<template>
  <div>
    <transition name="fade">
      <CallMe
        v-if="isOpen"
        @close="handleModalView"
        :companyphone="phone"
        :lang="lang"
      ></CallMe>
    </transition>
    <StickyContact @open="handleModalView" :lang="lang"></StickyContact>
  </div>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";
import axios from "axios";
import CallMe from "./CallMe/CallMe.vue";
import StickyContact from "./StickyContact/StickyContact.vue";

export default {
  name: "CtaContainer",
  mixins: [clickaway],
  props: {
    phone: {
      Type: Number,
    },
    lang: {
      Type: String,
    },
  },
  components: { CallMe, StickyContact },
  data: () => {
    return {
      isOpen: false,
    };
  },
  methods: {
    handleModalView: function() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>



// WEBPACK FOOTER //
// assets/_js/components/CtaContainer/CtaContainer.vue